import { createSlice } from "@reduxjs/toolkit";
import {         annexure_detailsThunk  } from "./thunk";


// slice for business point in home dashboard

export const initialState = {
  annexureDetailsData: [],
  annexureDetailsError: '', // for error message
  annexureDetailsLoading: false,
  
  
};

const Annexure_Get_Details = createSlice({
  name: "Annexure_Get_Details",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(annexure_detailsThunk.pending, (state) => {
      state.annexureDetailsLoading = true ;
      state.annexureDetailsData = [];
      state.annexureDetailsError = '';
  });
    builder.addCase(annexure_detailsThunk.fulfilled, (state, action) => {
        state.annexureDetailsData = action.payload.data;
        state.annexureDetailsLoading = false ;
    });
    builder.addCase(annexure_detailsThunk.rejected, (state, action) => {
      state.annexureDetailsError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.annexureDetailsLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  Annexure_Get_Details_Success,
  
} = Annexure_Get_Details.actions

export default Annexure_Get_Details.reducer;


